
import React from 'react';
import { DashboardLayout } from "@/components/dashboard/layout";
import StudentsPage from "@/features/students/StudentsPage";

const Students = () => {
  return (
    <DashboardLayout 
      title="Students" 
      description="Manage and track all students enrolled in your courses."
    >
      <StudentsPage />
    </DashboardLayout>
  );
};

export default Students;
